import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../common/Button';
import { openNotificationWithIcon } from '@mss/mss-component-library';
import { notification, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { routes } from 'jsx/common/constants';

type ISAEConfiguration = {
  asset: any;
  isae: any;
  location: string;
  device_id: string;
  device_tag: string;
  asset_config: {};
};
type DeleteConfigurationButtonProps = {
  configuration: ISAEConfiguration;
  configId: string;
  cb: any;
  isApplication?: boolean;
};

export default function DeleteConfigurationButton({
  configuration,
  configId,
  cb,
}: DeleteConfigurationButtonProps) {
  const [t] = useTranslation(['asset', 'common']);
  const history = useHistory();

  const deleteConfiguration = async (configuration: ISAEConfiguration) =>
    Modal.confirm({
      title: t('Are you sure you want to delete?'),
      icon: (
        <span className="anticon">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color="#fd9644"
            size="sm"
          />
        </span>
      ),
      content: (
        <div>
          <blockquote>{configuration.device_tag}</blockquote>
          <p>{t(`You're about to delete this configuration.`)}</p>
        </div>
      ),
      onOk: async () => {
        let result = await cb(configId);
        if (result.status === 200 || result.status === 204) {
          openNotificationWithIcon(
            notification.success,
            t('Configuration deleted'),
            t('ISAE configuration deleted successfully')
          );
          history.push(
            `/${routes.APPLICATIONS}/assetmanagement/isae/${configuration.isae.id}/isae-configuration/}`
          );
        } else {
          openNotificationWithIcon(
            notification.error,
            t('Configuration deletion failed'),
            t('Reason (REASON)', { reason: result.statusText })
          );
          console.error(t('Error!'), result);
        }
      },
      okButtonProps: { danger: true },
      okText: t('OK'),
      cancelText: t('Cancel'),
    });

  return (
    <Button
      onClick={() => deleteConfiguration(configuration)}
      data-ta="deleteConfigButton"
    >
      <FontAwesomeIcon icon={faBan} className="mr-1" />
      {t('DELETE CONFIGURATION')}
    </Button>
  );
}
